import './update-issuer-compliance-rule.scss'

import { notification } from 'antd'
import { Formik } from 'formik'
import { Form, FormItem, Input, InputNumber, SubmitButton } from 'formik-antd'
import React, { useEffect, useState } from 'react'
import { Column } from 'react-display-flex'

import { convertEntityValuesToFormValues } from '../../../../../util/convert-entity-values-to-form-values'
import { httpClient } from '../../../../../util/http-client'
import { issuerCompliancesRulesMessages } from '../messages'
import { IssuerComplianceRule } from '../models'
import { updateIssuerComplianceRuleValues } from './models'
import { issuerComplianceRuleValidationSchema } from './validators'

interface UpdateIssuerComplianceProps {
  groupId: number
  domain: string
  issuerComplianceRule: IssuerComplianceRule
  onSuccess?: () => void
}

export const UpdateIssuerCompliance = ({
  groupId,
  domain,
  issuerComplianceRule,
  onSuccess,
}: UpdateIssuerComplianceProps) => {
  const [tradeFormValues, setTradeFormValues] = useState(updateIssuerComplianceRuleValues)

  useEffect(() => {
    if (!issuerComplianceRule) return
    setTradeFormValues(convertEntityValuesToFormValues(updateIssuerComplianceRuleValues, issuerComplianceRule))
  }, [issuerComplianceRule])

  const onSubmit = async (formData) => {
    try {
      await httpClient(`/compliances/issuers/groups/${groupId}/rules/${issuerComplianceRule?.id}`, {
        method: 'PUT',
        domain,
        data: formData,
      })
      notification.success({
        message: issuerCompliancesRulesMessages.common.success,
        description: issuerCompliancesRulesMessages.update.success,
      })
      onSuccess && onSuccess()
    } catch (error) {
      notification.error({
        message: issuerCompliancesRulesMessages.common.error,
        description: error.error_message || issuerCompliancesRulesMessages.update.error,
      })
    }
  }

  return (
    <Formik
      initialValues={tradeFormValues}
      validationSchema={issuerComplianceRuleValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form name="update-issuer-compliance-rule">
        <FormItem name="ratingType" label="Rating Type" required>
          <Input name="ratingType" />
        </FormItem>
        <FormItem name="rating" label="Rating" required>
          <Input name="rating" />
        </FormItem>
        <FormItem name="maxLimit" label="Max Limit" required>
          <InputNumber name="maxLimit" />
        </FormItem>
        <Column>
          <SubmitButton htmlType="submit" type="primary">
            Save Rating
          </SubmitButton>
        </Column>
      </Form>
    </Formik>
  )
}
